import { render, staticRenderFns } from "./MyLive.vue?vue&type=template&id=f1fec074&scoped=true"
import script from "./MyLive.vue?vue&type=script&lang=js"
export * from "./MyLive.vue?vue&type=script&lang=js"
import style0 from "./MyLive.vue?vue&type=style&index=0&id=f1fec074&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fec074",
  null
  
)

export default component.exports